// pages/MaintenancePage.jsx
import React from "react";
import { Coffee } from "lucide-react";
import { Link } from "react-router-dom";

// Fin de la maintenance : le site rouvre automatiquement le 10 novembre 2026
// à 00:00 (heure de Genève). Modifier cette date pour prolonger ou raccourcir.
export const MAINTENANCE_END = new Date("2026-11-10T00:00:00+01:00");

// Pages qui restent accessibles pendant la maintenance (équipe, connexion, retours Stripe)
const ALWAYS_ALLOWED = [
	"/admin",
	"/pos",
	"/connexion",
	"/auth/callback",
	"/reset-password",
	"/mot-de-passe-oublie",
	"/verification-email",
	"/paiement-reussi",
	"/paiement-annule",
];

export const isMaintenanceActive = () => new Date() < MAINTENANCE_END;

export const isPathAllowedDuringMaintenance = (pathname) =>
	ALWAYS_ALLOWED.some(
		(p) => pathname === p || pathname.startsWith(`${p}/`)
	);

export default function MaintenancePage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-warm-alabaster px-6">
			<div className="max-w-lg w-full text-center">
				<div className="mx-auto mb-8 w-16 h-16 rounded-full bg-espresso flex items-center justify-center shadow-lg">
					<Coffee className="w-8 h-8 text-latte-gold" />
				</div>

				<p className="text-xs uppercase tracking-[0.3em] text-latte-gold font-sans font-semibold mb-4">
					Léger&apos;s Coffee
				</p>

				<h1 className="font-serif text-4xl md:text-5xl text-espresso mb-6">
					Site en maintenance
				</h1>

				<p className="font-sans text-espresso/70 leading-relaxed mb-2">
					Nous corrigeons actuellement un problème d&apos;affichage sur notre
					site internet.
				</p>
				<p className="font-sans text-espresso/70 leading-relaxed mb-10">
					Le site sera de nouveau disponible après le{" "}
					<span className="font-semibold text-espresso">9 novembre</span>.
					Le coffee shop reste ouvert, on vous attend !
				</p>

				<div className="pt-6 border-t border-espresso/10">
					<Link
						to="/connexion"
						className="text-xs font-sans text-espresso/40 hover:text-espresso/70 transition-colors"
					>
						Accès équipe
					</Link>
				</div>
			</div>
		</div>
	);
}
